module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"engineRebuildingOrdersBoard":"Tabla de Órdenes de la Rectificadora"},"en":{"engineRebuildingOrdersBoard":"Engine Rebuilding Orders Board"}}')
  delete Component.options._Ctor
}
